
export default function Philosophy() {
  return (
    <section className="bg-[#1A2B4A] py-24">
      <div className="max-w-4xl mx-auto px-8 lg:px-16 text-center">
        <p className="text-xs font-semibold tracking-[0.3em] uppercase text-white/50 mb-6">
          Operational Philosophy
        </p>
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6 leading-snug">
          Disciplined execution and measured capital allocation drive our growth model.
        </h2>
        <p className="text-base text-white/70 leading-relaxed max-w-2xl mx-auto">
          We prioritize scalable systems, operational efficiency, and long-duration asset appreciation across digital and real-world markets.
        </p>
      </div>
    </section>
  );
}
